const footerColumns = [
  {
    title: "栏目",
    items: [
      { key: "feed", label: "最新动态" },
      { key: "reversal", label: "反转精选" },
      { key: "timeline", label: "完整时间线" },
      { key: "responses", label: "各方回应" },
    ],
  },
  {
    title: "帮助",
    items: [
      { key: "tracking", label: "正在追踪" },
      { key: "about", label: "关于本站" },
      { key: "faq", label: "常见问题" },
      { key: "subscribe", label: "订阅追更" },
    ],
  },
];

export default function Footer() {
  const go = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-background-800 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div className="max-w-md">
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                go("top");
              }}
              className="flex items-center gap-2"
              aria-label="52爆料"
            >
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-xl font-black text-background-50">
                爆
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-background-50">52爆料</span>
                <span className="text-[9px] tracking-[0.28em] text-background-300/80">追更后续站</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              后续、反转、回应、时间线，一次整理清楚。让追更的人不再迷路，也不被断章取义牵着走——真相落地那天，是我们最有成就感的时候。
            </p>
            <p className="mt-3 font-accent text-xl text-accent-300">吃瓜要讲理，蹲更要耐心</p>
          </div>

          {footerColumns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="kicker text-[11px] font-bold uppercase text-accent-300">{col.title}</h4>
              <ul className="mt-4 grid grid-cols-1 gap-2.5">
                {col.items.map((item) => (
                  <li key={item.key}>
                    <a
                      href={`#${item.key}`}
                      onClick={(e) => {
                        e.preventDefault();
                        go(item.key);
                      }}
                      className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-background-200/85 transition-colors hover:text-accent-200"
                    >
                      <i className="ri-arrow-right-s-line text-accent-400" />
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-700/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300/70">
            © {new Date().getFullYear()} 52爆料 · 专注把事件讲清楚，后续不断更。
          </p>
          <ul className="flex flex-wrap items-center gap-4 text-xs text-background-300/70">
            <li>
              <button type="button" onClick={() => go("about")} className="transition-colors hover:text-accent-200">
                内容原则
              </button>
            </li>
            <li>
              <button type="button" onClick={() => go("faq")} className="transition-colors hover:text-accent-200">
                常见问题
              </button>
            </li>
            <li>
              <button type="button" onClick={() => go("subscribe")} className="transition-colors hover:text-accent-200">
                订阅追更
              </button>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}